import { z } from 'zod';
import { optionalTrimmedNullableString } from '../zod-helpers/optional-trimmed-nullable-string.js';
import { CARRIER_CONSTRAINTS } from './constraints.js';
import { serviceNameSchema } from './service-name-schema.js';
import { serviceNamesProblem } from './service-names-problem.js';
import { trackingUrlProblem } from './tracking-url-problem.js';
export const updateCarrierInputSchema = z
    .object({
    name: z
        .string()
        .trim()
        .min(1, `${CARRIER_CONSTRAINTS.name.label} cannot be empty.`)
        .max(CARRIER_CONSTRAINTS.name.maxLength)
        .optional(),
    trackingUrl: optionalTrimmedNullableString(CARRIER_CONSTRAINTS.trackingUrl.maxLength),
    serviceNames: z.array(serviceNameSchema).max(50).optional(),
})
    .superRefine((values, context) => {
    const trackingMessage = trackingUrlProblem(values.trackingUrl);
    if (trackingMessage) {
        context.addIssue({ code: 'custom', message: trackingMessage, path: ['trackingUrl'] });
    }
    const servicesMessage = serviceNamesProblem(values.serviceNames ?? []);
    if (servicesMessage) {
        context.addIssue({ code: 'custom', message: servicesMessage, path: ['serviceNames'] });
    }
});
//# sourceMappingURL=update-input.js.map